<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import addPvFieldsModal from './addPvFieldsGMapModalContent.vue'

export default {
  name: 'addPvFieldsButtonAndModal',
  components: {
    addPvFieldsModal
  },
  props: ['zone','parametre','nameproject','name','appurl','routesubmit','mode','champs','pvfields','site'],
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    afficheModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<template>
  <div>
    <button v-if="mode == 'add'" id="show-modal" class="buttonOriginal" @click="afficheModal"><span class="glyphicon glyphicon-plus" :title="trans.get('common.add')"></span></button>
    <button v-if="mode == 'edit'" id="show-modal" class="buttonOriginal" @click="afficheModal"><span class="glyphicon glyphicon-pencil" :title="trans.get('common.edit')"></span></button>
  
      <!-- use the modal component, pass in the prop -->
      <addPvFieldsModal v-if="showModal" @close="closeModal" :zone="this.zone" :parametre="this.parametre" :nameproject="this.nameproject" :name="this.name"  :appurl="this.appurl" :routesubmit="this.routesubmit" :champs="this.champs" :pvfields="this.pvfields" :site="this.site" :mode="this.mode"></addPvFieldsModal>
  </div>
</template>